import { formatNum } from '@/utils';

export const ScrollToDomById = (id: string) => {
  const dom = document.getElementById(id);
  const bar = document.getElementById('_anchor');
  if (!dom) return;

  const y = dom.getBoundingClientRect().y;

  window.scrollTo({
    // 58 是顶部选择的高度
    top: window.scrollY + y - 80 + (bar?.style.display === 'none' ? 58 : 0),
    behavior: 'smooth',
  });
};

export function isProfileIndex(location?: any) {
  return (location || window.location).pathname.split('/').length === 3;
}

export const getCurrentTabName = (pathname: string) => {
  const tabMap = {
    '/stream': 'Stream',
    '/nft': 'NFT',
    '/history': 'Transactions',
    '/analysis': 'Time_machine',
  };
  let tabName = 'Portfolio';
  Object.entries(tabMap).forEach(([key, value]) => {
    if (pathname.includes(key)) {
      tabName = value;
    }
  });
  return tabName;
};

export const formatHeaderInfoNum = (number?: number, digit = 0) => {
  if (!number && number !== 0) {
    return '-';
  }

  if (number < 10000) {
    return formatNum(number, digit, { truncate: number < 1000 });
  }

  return formatNum(number, 1, { abbrStart: 1 });
};
